export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13461.2a371661.jpg";